module.exports = __webpack_public_path__ + "static/media/twitter_icon.ab282184.svg";